<template>
    <ContainerWithMenu>
        <div class="page-content">
            <h1 class="h2 margin-bottom-20">{{ $t('views.transactions.title') }}</h1>
            <div class="table-responsive" v-if="orders.length > 0">
                <OrdersTable :orders="orders" :show-id="false" @show-receipt="showReceipt"></OrdersTable>
            </div>
            <div v-else>
                <span class="text-muted">{{ $t('views.transactions.not_found') }}</span>
            </div>
            <div class="text-center">
                <Pagination
                        v-show="numberPagesOrders > 1"
                        :page-count="numberPagesOrders"
                        :click-handler="paginateCallback" />
            </div>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
        <ReceiptModal :order="selectedOrder" v-show="showReceiptModal" :visible="showReceiptModal" @close-receipt-modal="showReceiptModal=false"></ReceiptModal>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import OrdersTable from "../components/order/OrdersTable";
    import {LIMIT_RECORDS_API, STATE_ORDER} from "../common/constants";
    import {Utils} from "../common/utils";
    import {getOrders} from "../api";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import Pagination from "../components/common/Pagination";
    import i18n from '../i18n'
    import ReceiptModal from "../components/modal/ReceiptModal";

    export default {
        title: i18n.t('views.transactions.title'),
        name: "Transactions",
        components: { ContainerWithMenu, Pagination, OrdersTable, SpinnerLoader, ReceiptModal },
        data: () => {
            return {
                orders: [],
                countOrders: 0,
                limitOrders: LIMIT_RECORDS_API,
                currentPageOrder: 1,
                loading: false,
                selectedOrder: {},
                showReceiptModal: false
            }
        },
        methods: {
            async getOrders(page = 1) {
                this.loading = true;
                try {
                    let ordersResponse = await getOrders(page, [STATE_ORDER.STATE_COMPLETED, STATE_ORDER.STATE_CANCELED]);
                    this.countOrders = ordersResponse.count;

                    this.orders = ordersResponse.results;
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            paginateCallback(pageNum) {
                this.getOrders(pageNum)
            },
            showReceipt(order) {
                this.selectedOrder = order;
                this.showReceiptModal = true;
            }
        },
        computed: {
            numberPagesOrders: function () {
                return Utils.getNumberPageByCountLimit(this.countOrders, this.limitOrders);
            }
        },
        mounted() {
            this.getOrders()
        }
    };
</script>
